import React from 'react'
import { TicketsList } from './list'

export const GoldenMay2026TicketsPage = () => {
  return <TicketsList />
}
